<template>
  <div>
    <v-layout row >
      <v-flex>
        <v-icon size="22" class="k-orange-linear-text mr-2 mb-2">
          {{ icon }}
        </v-icon>
        <span v-for="(item, i) in items" :key="`bc-${i}`" class="bread-crumbs">
          <span @click="goTo(item.url)" :class="{ 'hover-effect': item.url !== null }">
            {{ formatBc(item.title, i).text }}
          </span>
          <span class="separator">{{ formatBc(item.title, i).separator }}</span>
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    goTo(url) {
      if(url) {
        this.$router.push({
          path: url,
        });
      }
    },
    formatBc(item, index) {
      if (!this.items.length) {
        return { text: '', separator: '' };
      }

      const isLast = index === this.items.length - 1;
      return {
        text: item,
        separator: isLast ? '' : ' / '
      };
    }
  },
}
</script>

<style scoped>

.color-primary {
  color: #FF5F62 !important;
}

.color-black {
  color: #000000 !important;
}

ul.breadcrumb {
  padding: 10px 16px;
  list-style: none;
}


ul.breadcrumb li {
  display: inline;
  font-size: 15px;
  cursor: pointer;
  font-weight: 500;
}

ul.breadcrumb li a {
  text-decoration: none;
}
.cursor-default {
  pointer-events: none;
}
.hover-effect:hover {
    color: #FF7C64;
    cursor: pointer;
}
.separator {
  color: #7C8387;
}
.bread-crumbs {
  font: normal normal normal 20px/26px Roboto;
}
</style>


// WEBPACK FOOTER //
// src/components/global/BreadCrumbs.vue